import React from 'react';
import { TextCellProps } from '../types';

const variantClasses = {
  default: 'text-sm text-gray-700 dark:text-gray-300',
  muted: 'text-sm text-gray-600 dark:text-gray-400',
  emphasized: 'text-sm font-medium text-gray-900 dark:text-gray-100',
};

export const TextCell: React.FC<TextCellProps> = ({
  children,
  variant = 'default',
  className = '',
}) => {
  return (
    <span className={`${variantClasses[variant]} ${className}`}>
      {children}
    </span>
  );
};
